/**
 * @generated SignedSource<<43af0ed5e3e63807d5d1c25229190f10>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftDraftItemTileMedia_nftItemDraft$data = {
  readonly mainMedia: {
    readonly mimeType: string | null;
    readonly originalUrl: string | null;
    readonly videoThumbUrl: string | null;
  } | null;
  readonly name: string | null;
  readonly posterFrameMedia: {
    readonly displayUrl: string | null;
    readonly mimeType: string | null;
    readonly originalUrl: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly " $fragmentType": "NftDraftItemTileMedia_nftItemDraft";
};
export type NftDraftItemTileMedia_nftItemDraft$key = {
  readonly " $data"?: NftDraftItemTileMedia_nftItemDraft$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftDraftItemTileMedia_nftItemDraft">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mimeType",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "originalUrl",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftDraftItemTileMedia_nftItemDraft",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftMedia",
      "kind": "LinkedField",
      "name": "mainMedia",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "videoThumbUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftMedia",
      "kind": "LinkedField",
      "name": "posterFrameMedia",
      "plural": false,
      "selections": [
        (v0/*:: as any*/),
        (v1/*:: as any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "NftItemDraft",
  "abstractKey": null
};
})();

(node as any).hash = "680cbd3d4544323d9a7119ce75a7ad45";

export default node;
